<template>
  <div
    class="logo-mark"
    :class="`logo-mark--${tone}`"
    aria-label="VIPdesk Project Planner"
  >
    <img
      class="logo-mark__wordmark"
      src="/vipdesk-logo.png"
      alt=""
      width="1120"
      height="440"
    />
    <span class="logo-mark__product">Project Planner</span>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ tone?: "light" | "dark" }>(), { tone: "light" });
</script>

<style scoped>
.logo-mark {
  display: grid;
  align-items: center;
  width: fit-content;
  line-height: 1;
}
.logo-mark__wordmark {
  display: block;
  width: 116px;
  height: auto;
  object-fit: contain;
}
.logo-mark--dark .logo-mark__wordmark {
  filter: brightness(0) saturate(100%) invert(16%) sepia(19%) saturate(1354%)
    hue-rotate(159deg) brightness(92%) contrast(91%);
}
.logo-mark__product {
  margin-top: 3px;
  color: #b9cbd9;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.logo-mark--dark .logo-mark__product {
  color: var(--text-soft);
}
</style>
